import * as React from "react"
import { Col, Tooltip } from "reactstrap"
import styled from "styled-components"
import GetStaticImgUrl from "Placements/Utils/GetStaticImgUrl.util"
import GetStaticAudioUrl from "Placements/Utils/GetStaticAudioUrl.util";
import Loader from "Placements/Components/Loader"
import clone from "lodash/clone"

import ExerciseQuestionStyle from "Placements/Fields/Exercises/ChooseMultiple.field/ExerciseQuestion.style"
import ExerciseRowStyle from "Placements/Fields/Exercises/ChooseMultiple.field/ExerciseRow.style"
import ExerciseSubStatementStyle from "Placements/Fields/Exercises/ChooseMultiple.field/ExerciseSubStatement.style"
import AudioPlayerColStyle from "Placements/Fields/Exercises/ChooseMultiple.field/AudioPlayerCol.style"
import DivCollapseStyle from "Placements/Fields/Exercises/ChooseMultiple.field/DivCollapse.style"
import GetNewHtmlReplaceImg from "Placements/Utils/GetNewHtmlReplaceImg.util"
import AudioPlayer from "Placements/Components/AudioPlayer"


const SpanStyled = styled.span`
    b, strong {
        font-weight:normal!important;
        font-family:Panton-Bold;
    }
`

const Button = styled.button`
`
const HeaderButtonStyle = styled(Button)`
`
const HrCollapseStyle = styled.hr`
`

const FigureStyle = styled.figure`
    @media screen and (min-width: 768px) {
        padding: 1rem;
        margin: 0;
    }

    img {
        width: 100%;
    }
`



class ChooseMultiple extends React.Component<ExerciseFieldPropsType, {
    loadingAnwers: boolean
    respostaUsuario: any
    //answer: any
    collapse: boolean
    options: any
    tooltipOpen: boolean
    isStudent: boolean
    isDisabledViewAnswers: boolean
}> {
    constructor(props: any) {
        super(props)
        this.state = {
            loadingAnwers: false,
            //answer: null,
            options: this.embaralhaOpRespostas(props.exercise.respostas_Exercicio_Yconnect),
            respostaUsuario: null,
            collapse: true,
            tooltipOpen: false,
            isStudent: true,
            isDisabledViewAnswers: true,
        }
    }

    embaralhaOpRespostas(respostas: any) {
        let retorno = clone(respostas)

        if (respostas) {
            /* Embaralha as respostas, e armazena nas opções de respostas */
            for (var i = 0; i < respostas.length; i++) {
                var r1 = Math.floor(Math.random() * respostas.length)
                var r2 = Math.floor(Math.random() * respostas.length)

                var aux = retorno[r2]
                retorno[r2] = retorno[r1]
                retorno[r1] = aux
            }
        }

        return retorno
    }

    handleChange = (event: any) => {
        const {
            props: { id, onChange, exercise }
        } = this
        const { currentTarget: { value } } = event

        //const answer = find(exercise.respostas_Exercicio_Yconnect, { ordem: Number(value)})
        onChange(id, {
            //qntd_acertos: answer.correta ? 1 : 0,
            //qntd_respostas: 1,
            resposta: value
        })
        //this.setState({ respostaUsuario: null, answer: value })
    }

    render() {
        const {
            props: {
                id,
                exercise,
                attempts,
                answer,
            },
            state: {
                isStudent,
                isDisabledViewAnswers,
                respostaUsuario,
                loadingAnwers,
                collapse,
                options,
                //answer,
            },
            handleChange,
        } = this

        if (loadingAnwers) {
            return <Loader />
        }

        const hasAudio = (exercise.midia_Yconnect[0] || {}).tipo_midia === 'audio'
        const hasImg = (exercise.midia_Yconnect[1] || {}).tipo_midia === 'image'

        return (
            <>
                {
                    !isDisabledViewAnswers
                    && <div className="pl-2 pr-2 pl-lg-4 pr-lg-4 w-100">
                        {(attempts >= 2 || !isStudent) ?
                            <HeaderButtonStyle
                                className="float-right"
                                label="View Answers"
                                //onClick={this.showCorrectAnswers}
                                icon="checkedGreen2"
                            />
                            :
                            <>
                                <HeaderButtonStyle
                                    id="completeResultToolTip"
                                    className="float-right disabled view-answers"
                                    label="View Answers"
                                    icon="checkedGreen2"
                                />
                                <Tooltip placement="right" isOpen={this.state.tooltipOpen} target="completeResultToolTip" toggle={() => this.setState(state => ({ tooltipOpen: !state.tooltipOpen }))}>
                                    Oops, you'll only be able to know the correct answers once you've checked your own answers in the 1st and 2nd attempts.
                            </Tooltip>
                            </>
                        }
                    </div>}
                {exercise.ajuda || exercise.texto || hasAudio ?
                    <ExerciseSubStatementStyle className="w-100">
                        {/** Ajuda */}
                        <div className="w-100 text-center">
                            <h2 dangerouslySetInnerHTML={{ __html: exercise.ajuda }}></h2>
                        </div>

                        {/** texto */}
                        {exercise.texto ?
                            <ExerciseRowStyle className="exercise-dialogue">
                                <Col className="exercise-dialogue-content" md="12" lg="12">
                                    <div className="exercise-dialogue-text mb-5 d-block w-100">
                                        <DivCollapseStyle defaultOpen={true} toggler="#toggler" dangerouslySetInnerHTML={{ __html: GetNewHtmlReplaceImg(exercise.texto) }} />
                                        <HrCollapseStyle />
                                        <Button
                                            color="link"
                                            id="toggler"
                                            className="button-collapsed"
                                            size="sm"
                                            onClick={() => this.setState(state => ({ collapse: !state.collapse }))}>
                                            {collapse ? '- Hide text' : '+ Show text'}
                                        </Button>
                                    </div>
                                </Col>
                            </ExerciseRowStyle>
                            :
                            ''
                        }

                        {/** audio */}
                        {hasAudio ?
                            <AudioPlayerColStyle
                                className=" mb-3"
                                xs="12"
                                md={{ size: 6, offset: 3 }}
                                lg={{ size: 6, offset: 3 }}
                            >
                                <AudioPlayer
                                    src={GetStaticAudioUrl(exercise.midia_Yconnect[0].url)}
                                />
                            </AudioPlayerColStyle>
                            :
                            <>
                                {/** image */}
                                {hasImg &&
                                    <FigureStyle>
                                        <img src={GetStaticImgUrl( exercise.midia_Yconnect[1].url)} alt="" />
                                    </FigureStyle>

                                }
                            </>
                        }
                    </ExerciseSubStatementStyle>
                    :
                    ''
                }

                {/** Sub Enunciado */}
                {exercise.conteudo_exercicio ?
                    <ExerciseRowStyle className="exercise-dialogue mt-4">
                        <Col className="exercise-dialogue-content text-center w-100" md="12" lg="12">
                            <div className="exercise-dialogue-text">
                                <h4 dangerouslySetInnerHTML={{ __html: GetNewHtmlReplaceImg(exercise.conteudo_exercicio) }}></h4>
                            </div>
                        </Col>
                    </ExerciseRowStyle>
                    :
                    ''
                }

                {/** Opções */}
                <ExerciseQuestionStyle className={`text-center w-100 ${exercise.conteudo_exercicio ? '' : 'mt-4'}`}>
                    <div className="btn-group btn-group-toggle m-auto"
                        data-toggle="buttons"
                        id={"" + id}>
                        {
                            options.map((option: any, key: number) => {

                                return (
                                    <label
                                        key={key}
                                        className={`btn btn-radio ${`${answer}` === `${option.ordem}` ? 'active' : ''} ${`${respostaUsuario}` === `${option.ordem}` ? option.correta ? 'correct' : 'wrong' : ''}`}
                                    >
                                        <input
                                            type="radio"
                                            id={option.id_resposta}
                                            value={option.ordem}
                                            onClick={handleChange}
                                        />
                                        <SpanStyled dangerouslySetInnerHTML={{ __html: option.resposta }} />
                                    </label>
                                )
                            })
                        }
                    </div>
                </ExerciseQuestionStyle>
            </>
        )
    }
}

export default ChooseMultiple
